// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__2fNAF","pencil":"IconEdit_pencil__3Vq7F"};